import { socialLogin } from './socialSignOn';

import { isGoogleCredentialResponse } from './socialSignOnTypes';
import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import { UserIdentity } from './userIdentity';

/**
 * Intended to be used as a callback (passed as `callback`) to the `google.accounts.id.initialize` provided by Google.
 * Please refer to [Google Identity documentation](https://developers.google.com/identity/gsi/web/guides/display-button).
 *
 * @returns
 * A __Promise__ resolving to a user's identity. When successful, updates Identity.userIdentity witih this information
 *
 */
export default async function signInWithGoogle(
  response: globalThis.google.accounts.id.CredentialResponse): Promise<UserIdentity | APIErrorResponse> {
  if (isGoogleCredentialResponse(response)) {
    return await socialLogin('google', {
      credentials: response.credential
    });
  } else {
    throw new Error(`[Arc Identity SDK]: Error getting google jwt credential. ${response}`);
  }
}
